import {usePullRequestState} from '../../../../hooks/use-pull-request-state'
import {PullRequestState} from '../../../../types'
import {useOverviewRouteData} from '../../data/use-overview-route-data'
import type {ViewerRole} from '../deciders/use-decide-next-action'
import {DeleteHeadBranch, shouldShowDeleteHeadBranch} from './DeleteHeadBranch'
import {RestoreHeadBranch} from './RestoreHeadBranch'
import {ReopenPullRequest} from './ReopenPullRequest'
import {useMergeabilityData} from '../mergeability/use-mergeability-data'
import {GitPullRequestClosedIcon} from '@primer/octicons-react'
import {ForYouItem} from '../shared/ForYouItem'
import {ForYouLeadingIcon} from '../shared/ForYouLeadingIcon'

export function shouldShowClosedPR(pullRequestState: PullRequestState) {
  return pullRequestState === PullRequestState.Closed
}

export function ClosedPR({variant, userRole}: {variant?: 'default' | 'embedded'; userRole?: ViewerRole}) {
  const pullRequestState = usePullRequestState()
  const {user} = useOverviewRouteData().data
  const mergeabilityData = useMergeabilityData()

  if (!shouldShowClosedPR(pullRequestState)) return null

  if (userRole && userRole !== 'author') {
    return (
      <ForYouItem
        leadingVisual={<ForYouLeadingIcon icon={GitPullRequestClosedIcon} variant="danger" emphasized />}
        emphasizedLeadingVisual
        title="Closed"
        itemName="closed"
        variant={variant}
        description="Nothing to do."
      />
    )
  }

  const canRestoreHeadRef = Boolean(mergeabilityData?.mergeBoxPullRequest.viewerCanRestoreHeadRef)
  const canReopenPullRequest = Boolean(user?.canReopen && !canRestoreHeadRef)

  return (
    <>
      {shouldShowDeleteHeadBranch(mergeabilityData) && <DeleteHeadBranch variant={variant} />}
      {canRestoreHeadRef ? (
        <RestoreHeadBranch variant={variant} />
      ) : (
        <ReopenPullRequest canReopen={canReopenPullRequest} variant={variant} />
      )}
    </>
  )
}
